import React, { useState, useRef, useEffect } from "react";
import PropTypes from "prop-types";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import { makeStyles } from "@material-ui/core/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import useScrollTrigger from "@material-ui/core/useScrollTrigger";
import Container from "@material-ui/core/Container";
import Fab from "@material-ui/core/Fab";
import Zoom from "@material-ui/core/Zoom";
import icon from "../../assets/img/logo_primary.svg";
import CardShowcase from "../../assets/svg/card.svg";

import Cards from "../../assets/svg/cards.svg";
import Dashboard from "../../assets/svg/dashboard.svg";
import Booking from "../../assets/svg/booking.svg";
import Mobile from "../../assets/svg/mobile.svg";
import Kiosk from "../../assets/svg/kiosk.png";
import Ussd from "../../assets/svg/ussd.png";

import { useTheme } from "@material-ui/core/styles";

import {
  Tab,
  Tabs,
  Box,
  Grid,
  Typography,
  Paper,
  Button,
  IconButton,
  TextField,
  Badge,
  Checkbox,
  FormControlLabel,
} from "@material-ui/core";
import {
  Slide,
  CircularProgress,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  CardHeader,
  Avatar,
  Drawer,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  useMediaQuery,
} from "@material-ui/core";
import {
  Twitter,
  RadioButtonCheckedRounded,
  ChevronLeftRounded,
  ChevronRightRounded,
  MoreVertRounded,
  FormatQuoteRounded,
  KeyboardArrowUpRounded,
  HomeRounded,
  InfoRounded,
  ContactMailRounded,
  HelpRounded,
  ViewCompactRounded,
  MenuRounded,
  Timeline,
  Equalizer,
  PieChart,
  DirectionsBus,
} from "@material-ui/icons";

import Footer from "./footer.jsx";

import { useHistory } from "react-router-dom";

const useStyles = makeStyles((theme) => ({
  root: {
    position: "fixed",
    bottom: theme.spacing(2),
    right: theme.spacing(2),
  },
}));

function ScrollTop(props) {
  const { children, window } = props;
  const classes = useStyles();
  // Note that you normally won't need to set the window ref as useScrollTrigger
  // will default to window.
  // This is only being set here because the demo is in an iframe.
  const trigger = useScrollTrigger({
    target: window ? window() : undefined,
    disableHysteresis: true,
    threshold: 100,
  });

  const handleClick = (event) => {
    const anchor = (event.target.ownerDocument || document).querySelector(
      "#back-to-top-anchor"
    );

    if (anchor) {
      anchor.scrollIntoView({ behavior: "smooth", block: "center" });
    }
  };

  return (
    <Zoom in={trigger}>
      <div onClick={handleClick} role="presentation" className={classes.root}>
        {children}
      </div>
    </Zoom>
  );
}

const useStyles2 = makeStyles((theme) => ({
  root: {
    borderRadius: 15,
  },
  tab: {
    textTransform: "capitalize",
    fontSize: 18,
  },
  tabs: {
    display: "block",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  icon: {
    display: "block",
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  icon2: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  ln: {
    height: 2,
    width: 100,
    backgroundColor: theme.palette.primary.main,
    marginLeft: 10,
  },
  ln2: {
    height: 2,
    width: 100,
    backgroundColor: theme.palette.primary.main,
    marginRight: 10,
    display: "block",
    [theme.breakpoints.down("xs")]: {
      display: "none",
    },
  },
  media: {
    height: 170,
  },
  btn: {
    textTransform: "capitalize",
  },
  btn2: {
    textTransform: "capitalize",
    border: "dashed grey 1px",
  },
  paper: {
    padding: 15,
  },
  title: {
    flexGrow: 1,
  },
  menu: {
    display: "none",
    marginRight: 16,
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },

  illu: {
    position: "absolute",
    zIndex: -20,

    backgroundSize: "100% 100%",
  },
  illu2: {
    zIndex: -20,
  },
  green: {
    height: 60,
    width: 60,
    background: theme.palette.primary.main,
  },
  test: {
    color: "#fff",
  },
}));

const reviews = [
  // { name: "Regis saffi", work: "Software developer", title: "Excelent", message: "sjdvd dd d sd dj f hdfsdjf sg fsg fsg shg sjgf sd sbg sgsgfewufew gfwehg wwkg we" },
  {
    name: "Drake NKUNDA",
    work: "Tech guru",
    title: "TIMELY, EFFICIENT, AND USE THE BEST PRACTICES IN THEIR WORK.",
    message:
      "I have been involved in big projects for major corporations but the team at CENTRIKA is the best that I have worked with. They are timely, efficient and use best practices in their TECH projects. Their society inclusion in most of their projects is outstanding. I would recommend them to anyone.",
  },
  {
    name: "IMMY MULEKATETE",
    work: "Parent",
    title: "THE MOST INNOVATIVE TECH COMPANY.",
    message:
      " As a parent, I am very pleased with the project you have done, and especially your commitment to providing a qualitsolution when it meant going the extra mile to do so. The SPS project is really mind-blowing, and I couldn’t think of a better way to get involved in my children’s education. SafariBus is the tech Company we were looking forward to.<br>Kudos!!! And keep up the awesome Inventions.",
  },
  {
    name: "CYUSA Benjamin",
    work: "Web developer",
    title: "EXCELENT COMPANY",
    message:
      "SafariBus has always excelled professionally throughout all the projects we’ve had together, and their high- end expertise will double your will to run more projects with these Tech experts. They respond to customer’s needs and consistently outstrip their expectations. <br> Personally, I commend this company to anyone out there looking for a quality and professional tech service.",
  },
];

export default function LandingHome(props) {
  const classes = useStyles2();
  const theme = useTheme();
  const history = useHistory();

  const fullScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const welcomeRef = useRef(null);
  const contactRef = useRef(null);
  const aboutRef = useRef(null);
  const productRef = useRef(null);
  const requestRef = useRef(null);

  const scrollToRef = (ref) => window.scrollTo(0, ref.current.offsetTop - 70);

  const [drawerOpen, setDrawerOpen] = useState(false);
  const [activeReview, setActiveReview] = useState(0);

  const [currentTab, setCurrentTab] = useState(0);
  const [contactNames, setContactNames] = useState({ value: "", error: "" });
  const [contactEmail, setContactEmail] = useState({ value: "", error: "" });
  const [contactMessage, setContactMessage] = useState({
    value: "",
    error: "",
  });
  const [offset, setOffset] = useState(0);

  useEffect(() => {
    window.onscroll = function () {
      // console.log(window.pageYOffset);
      setOffset(window.pageYOffset);
    };
  }, []);

  const handleTabChange = (e, v) => {
    setCurrentTab(v);
    switch (v) {
      case 0:
        scrollToRef(welcomeRef);
        break;
      case 1:
        scrollToRef(aboutRef);
        break;
      case 2:
        scrollToRef(productRef);
        break;
      case 3:
        scrollToRef(requestRef);
        break;
      default:
        scrollToRef(aboutRef);
        break;
    }
  };

  const toggleDrawer = () => {
    setDrawerOpen(!drawerOpen);
  };

  const handleDrawerClick = (ref) => {
    toggleDrawer();
    scrollToRef(ref);
  };

  const handleContactNamesChange = (e) => {
    if (e.target.value === "") {
      setContactNames({ value: "", error: "Enter your names here" });
    } else {
      setContactNames({ value: e.target.value, error: "" });
    }
  };
  const handleContactEmailChange = (e) => {
    if (e.target.value === "") {
      setContactEmail({ value: "", error: "Enter your email here" });
    } else {
      setContactEmail({ value: e.target.value, error: "" });
    }
  };
  const handleContactMessageChange = (e) => {
    if (e.target.value === "") {
      setContactMessage({ value: "", error: "Enter your message here" });
    } else {
      setContactMessage({ value: e.target.value, error: "" });
    }
  };

  const handleSendClick = () => {
    if (contactNames.value === "") {
      setContactNames({ ...contactNames, error: "Enter your names here" });
    } else if (contactEmail.value === "") {
      setContactEmail({ ...contactEmail, error: "Enter your email here" });
    } else if (contactMessage.value === "") {
      setContactMessage({
        ...contactMessage,
        error: "Write your message here",
      });
    } else {
    }
  };
  return (
    <React.Fragment>
      <CssBaseline />

      <Drawer anchor="left" open={drawerOpen} onClose={() => toggleDrawer()}>
        <Box p={3} dislpay="flex" width={1} justifyContent="center">
          <img
            src={icon}
            style={{ height: 50 }}
            alt="Icon"
            onClick={() => scrollToRef(welcomeRef)}
          />
        </Box>
        <List style={{ width: 240 }}>
          <ListItem
            button
            key={0}
            onClick={() => handleDrawerClick(welcomeRef)}
          >
            <ListItemIcon>
              <HomeRounded />
            </ListItemIcon>
            <ListItemText primary="Home" />
          </ListItem>
          <ListItem button key={1} onClick={() => handleDrawerClick(aboutRef)}>
            <ListItemIcon>
              <InfoRounded />
            </ListItemIcon>
            <ListItemText primary="About" />
          </ListItem>
          <ListItem
            button
            key={2}
            onClick={() => handleDrawerClick(productRef)}
          >
            <ListItemIcon>
              <ViewCompactRounded />
            </ListItemIcon>
            <ListItemText primary="Products" />
          </ListItem>
          <ListItem
            button
            key={3}
            onClick={() => handleDrawerClick(requestRef)}
          >
            <ListItemIcon>
              <HelpRounded />
            </ListItemIcon>
            <ListItemText primary="Request" />
          </ListItem>
        </List>
      </Drawer>

      <Box width={1} height={600} className={classes.illu}>
        <Box
          width={1}
          height={1}
          className={classes.illu2}
          bgColor="primary.contrastText"
        ></Box>
      </Box>
      <AppBar
        elevation={0}
        position="sticky"
        color={offset < 100 ? "transparent" : "default"}
        ref={welcomeRef}
      >
        <Toolbar>
          <IconButton
            color="primary"
            aria-label="open drawer"
            onClick={toggleDrawer}
            edge="start"
            className={classes.menu}
          >
            <MenuRounded />
          </IconButton>

          <img
            src={icon}
            style={{ height: 45 }}
            className={classes.icon}
            alt="Icon"
            onClick={() => history.push("/login")}
          />

          {!fullScreen ? (
            <Box display="flex" flexGrow={1}></Box>
          ) : (
            <Typography variant="h6" color="primary" className={classes.title}>
              SafariBus
            </Typography>
          )}
          <Box
            mb="-16px"
            className={classes.tabs}
            fontWeight="fontWeightMedium"
          >
            <Tabs
              value={currentTab}
              indicatorColor="primary"
              textColor="primary"
              onChange={handleTabChange}
              aria-label="tabs example"
              scrollButtons="on"
              variant="scrollable"
            >
              <Tab className={classes.tab} label="Home" />
              <Tab className={classes.tab} label="About us" />
              <Tab className={classes.tab} label="Products" />
              <Tab className={classes.tab} label="Request" />
            </Tabs>
          </Box>
          <img
            src={icon}
            style={{ height: 35 }}
            className={classes.icon2}
            alt="Icon"
            onClick={() => scrollToRef(welcomeRef)}
          />
        </Toolbar>
      </AppBar>
      <Toolbar id="back-to-top-anchor" />

      <Box mt={6} />
      <Container>
        <Grid container spacing={3} justify="center">
          <Grid item xs={12} sm={12} md={6}>
            <Box
              display="flex"
              flexDirection="column"
              width={1}
              height={1}
              justifyContent="center"
            >
              <Box display="flex" alignItems="center">
                {" "}
                <Typography
                  color="textsecondary"
                  variant="h4"
                  gutterBottom
                  noWrap
                >
                  Welcome to{" "}
                </Typography>
                <div className={classes.ln} />
              </Box>
              <Typography variant="h2">
                <b>SafariBus platform</b>
              </Typography>
              <Typography color="textsecondary">
                An integrated platform inspired by technology to contribute to
                lasting solutions.
              </Typography>

              <Box mt={1}>
                <Button
                  variant="contained"
                  color="primary"
                  size="large"
                  disableElevation
                  onClick={() => scrollToRef(aboutRef)}
                  className={classes.btn}
                >
                  Discover more
                </Button>
              </Box>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={6}>
            <Box
              display="flex"
              width={1}
              justifyContent="center"
              flexDirection="column"
            >
              <img
                src={CardShowcase}
                style={{ height: 170 }}
                alt="Cards showcase"
              />

              <Box mt={1} display="flex" width={1} justifyContent="center">
                {/* <Badge badgeContent="New" color="error" variant="standard"> */}
                  <Button
                    variant="contained"
                    color="primary"
                    disableElevation
                    onClick={() => history.push("/preRegister")}
                    className={classes.btn}
                  >
                    Pre-register
                  </Button>
                {/* </Badge> */}
                {/* <Box ml={4}>
                  <Badge badgeContent="New" color="secondary" variant="standard">
                    <Button
                      variant="contained"
                      color="primary"
                      disableElevation
                      onClick={() => history.push("/ekashRegistration")}
                      className={classes.btn}
                    >
                      eKash
                    </Button>
                  </Badge>
                </Box> */}

              <Box ml={4}>
                <Badge badgeContent="New" color="secondary" variant="standard">
                  <Button
                    variant="contained"
                    color="primary"
                    disableElevation
                    onClick={() => history.push("/card-topup")}
                    className={classes.btn}
                  >
                    Card topup
                  </Button>
                </Badge>
              </Box>
              

              <Box ml={4}>
                <Badge badgeContent="New" color="error" variant="standard">
                  <Button
                    variant="contained"
                    color="primary"
                    disableElevation
                    onClick={() => history.push("/checkBalance")}
                    className={classes.btn}
                  >
                    Balance
                  </Button>
                </Badge>
              </Box>

              </Box>
            </Box>
          </Grid>
        </Grid>

        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mt={12}
          alignContent="center"
          width={1}
          ref={aboutRef}
        >
          {" "}
          <div className={classes.ln2} />
          <Typography variant="h4" gutterBottom noWrap>
            <b>About SafariBus </b>
          </Typography>
          <div className={classes.ln} />
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mb={10}
          alignContent="center"
          width={1}
        >
          <Box width={!fullScreen ? 1 / 2 : 1}>
            <Typography align="center">
            Safaribus is platform Powered by Centrika Ltd a fintech and software development company which provides ticket booking facilities through its website which connects bus travellers as it  also facilitates financial transactions.
            </Typography>
          </Box>
        </Box>

        <Grid container spacing={3} justify="center" alignContent="center">
          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2}>
                <Avatar className={classes.green}>
                  <Timeline fontSize="large" />
                </Avatar>
              </Box>

              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                align="center"
                color="primary"
              >
                About us
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                We use an enabling software and hardware infrastructure, to
                provide crucial services in finance, transport, events and
                sports, all in a bid to improve …
              </Typography>
            </CardContent>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2}>
                <Avatar className={classes.green}>
                  <Equalizer fontSize="large" />
                </Avatar>
              </Box>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                color="primary"
                align="center"
              >
                Our services
              </Typography>
              <Typography color="textSecondary" component="p" align="center">
                With all the information in place you will be presented with an
                action plan that your company needs to follow and achieve its
                goals with us ...
              </Typography>
            </CardContent>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <CardContent>
              <Box display="flex" justifyContent="center" width={1} mb={2}>
                <Avatar className={classes.green}>
                  <DirectionsBus fontSize="large" />
                </Avatar>
              </Box>
              <Typography
                gutterBottom
                variant="h5"
                component="h2"
                color="primary"
                align="center"
              >
                Our partners
              </Typography>
              <Typography align="center" color="textSecondary" component="p">
                Most of our partners and suppliers are the largest in the
                business and they give us a powerful advantage to serve you
                better and cater to your needs.
              </Typography>
            </CardContent>
          </Grid>
        </Grid>

        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mt={10}
          alignContent="center"
          width={1}
          ref={productRef}
        >
          {" "}
          <div className={classes.ln2} />
          <Typography variant="h4" gutterBottom noWrap>
            <b>SafariBus products</b>
          </Typography>
          <div className={classes.ln} />
        </Box>
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          mb={10}
          alignContent="center"
          width={1}
        >
          <Box width={1 / 2}>
            <Typography align="center">
              Our products and solutions available.
            </Typography>
          </Box>
        </Box>

        <Grid container spacing={3} alignContent="center">
          <Grid item xs={12} sm={4} md={3}>
            <Card className={classes.root} elevation={0}>
              <Box display="flex" width={1} justifyContent="center">
                <img
                  height={80}
                  className={classes.media}
                  src={Mobile}
                  alt="SafariBus"
                />
              </Box>
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  SafariBus app
                </Typography>
                <Typography color="textSecondary" component="p">
                  This game changer app basically enables a client to either
                  book or hire a bus beforehand. The exciting part …
                </Typography>
              </CardContent>

              <CardActions>
                <Button color="primary" className={classes.btn}>
                  Learn more
                </Button>
              </CardActions>
            </Card>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <Card className={classes.root} elevation={0}>
              <Box display="flex" width={1} justifyContent="center">
                <img
                  height={80}
                  className={classes.media}
                  src={Booking}
                  alt="Booking"
                />
              </Box>
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Safaribus online
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  You are in an office or you don't have a smartphone, don't
                  worry, you can still book your tickets on the go.
                </Typography>
              </CardContent>

              <CardActions>
                <Button color="primary" className={classes.btn}>
                  Learn more
                </Button>
              </CardActions>
            </Card>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <Card className={classes.root} elevation={0}>
              <img
                height={80}
                className={classes.media}
                src={Dashboard}
                alt="Dashboard"
              />
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Safaribus portal
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Distributed solution designed for service providers in our
                  transport with it's efficient of use..
                </Typography>
              </CardContent>

              <CardActions>
                <Button color="primary" className={classes.btn}>
                  Learn more
                </Button>
              </CardActions>
            </Card>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <Card className={classes.root} elevation={0}>
              <Box display="flex" width={1} justifyContent="center">
                <img
                  height={80}
                  className={classes.media}
                  src={Cards}
                  alt="Cards"
                />
              </Box>
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Safaribus cards
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  Integrated next level cards which can be used from paying a
                  bus ticket to paying your gloceries on your local market..
                </Typography>
              </CardContent>

              <CardActions>
                <Button color="primary" className={classes.btn}>
                  Learn more
                </Button>
              </CardActions>
            </Card>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <Card className={classes.root} elevation={0}>
              <Box display="flex" width={1} justifyContent="center">
                <img
                  height={120}
                  className={classes.media}
                  src={Kiosk}
                  alt="Kiosk"
                />
              </Box>
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Safaribus KeyKiosk
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  This is a self-service top- notch payment mode system that
                  provides a great deal of services that are entirely …
                </Typography>
              </CardContent>

              <CardActions>
                <Button size="small" color="primary" className={classes.btn}>
                  Learn more
                </Button>
              </CardActions>
            </Card>
          </Grid>

          <Grid item xs={12} sm={4} md={3}>
            <Card className={classes.root} elevation={0}>
              <Box display="flex" width={1} justifyContent="center">
                <img
                  height={80}
                  className={classes.media}
                  src={Ussd}
                  alt="Ussd"
                />
              </Box>
              <CardContent>
                <Typography gutterBottom variant="h5" component="h2">
                  Safaribus USSD
                </Typography>
                <Typography variant="body2" color="textSecondary" component="p">
                  No smartphone or a computer yet? you can still book your
                  ticket using whatever mobile phone you might be using..'
                </Typography>
              </CardContent>

              <CardActions>
                <Button size="small" color="primary" className={classes.btn}>
                  Learn more
                </Button>
              </CardActions>
            </Card>
          </Grid>
        </Grid>

        <Box mt={10} />
        <Grid container spacing={3} justify="center">
          <Grid item xs={12} sm={12} md={5}>
            <Box
              display="flex"
              justifyContent="flex-start"
              alignItems="center"
              width={1}
            >
              <Typography variant="h4" gutterBottom noWrap>
                <b>Our values</b>
              </Typography>
              <div className={classes.ln} />
            </Box>
            <Box display="flex" justifyContent="flex-start" mb={2} width={1}>
              <Box width={1}>
                <Typography gutterBottom>
                  One thing that defines the most successful companies is their
                  values. At SafariBus, the values we stand by that shape our
                  culture, our work ethics, and our decisions that help us be
                  more than what we were yesterday are:
                </Typography>
              </Box>
            </Box>
            <Box display="flex" alignItems="flex-start" p={1}>
              <Box mt="3px" mr={2}>
                {" "}
                <RadioButtonCheckedRounded color="primary" fontSize="small" />
              </Box>
              <Typography>
                <b>Customer centric: </b> To focus on the customers’ needs and
                surpass their expectations consistently.
              </Typography>
            </Box>
            <Box display="flex" alignItems="flex-start" p={1}>
              <Box mt="3px" mr={2}>
                {" "}
                <RadioButtonCheckedRounded color="primary" fontSize="small" />
              </Box>
              <Typography>
                <b>Innovation: </b> To continuously develop solutions that solve
                customers’ needs.
              </Typography>
            </Box>
            <Box display="flex" alignItems="flex-start" p={1}>
              <Box mt="3px" mr={2}>
                {" "}
                <RadioButtonCheckedRounded color="primary" fontSize="small" />
              </Box>
              <Typography>
                <b>Integrity and Transparency: </b> To be ethical and sincere in
                all our transactions.
              </Typography>
            </Box>
            <Box display="flex" alignItems="flex-start" p={1}>
              <Box mt="3px" mr={2}>
                {" "}
                <RadioButtonCheckedRounded color="primary" fontSize="small" />
              </Box>
              <Typography>
                <b>Excellence: </b> To strive relentlessly;- constantly improve
                ourselves, our teams, and our products and services to become
                the best.
              </Typography>
            </Box>
            <Box mt={1}>
              <Button
                variant="contained"
                color="primary"
                size="large"
                disableElevation
                onClick={() => scrollToRef(contactRef)}
                className={classes.btn}
              >
                Contact us
              </Button>
            </Box>
          </Grid>
        </Grid>

        <Box mt={10} />
        <Grid container spacing={3} justify="center">
          <Grid item xs={12} sm={12} md={5}>
            <Box
              bgcolor="secondary.main"
              width={1}
              height={1}
              display="flex"
              flexDirection="column"
              justifyContent="center"
              borderRadius="borderRadius"
              alignItems="center"
              px={5}
              py={10}
            >
              <Box fontSize="42">
                <FormatQuoteRounded color="primary" />
              </Box>
              <Typography
                variant="h3"
                gutterBottom
                color="initial"
                className={classes.test}
              >
                Testimonials
              </Typography>
              <Typography variant="h5" gutterBottom className={classes.test}>
                Success stories of customers
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={5}>
            <Card style={{ height: "100%" }} elevation={0}>
              <CardHeader
                avatar={
                  <Avatar aria-label="Drake" className={classes.avatar}>
                    {reviews[activeReview].name.substring(0, 1)}
                  </Avatar>
                }
                action={
                  <IconButton aria-label="More">
                    <MoreVertRounded />
                  </IconButton>
                }
                title={reviews[activeReview].name}
                subheader={reviews[activeReview].work}
              />
              {reviews.map((t, i) => (
                <Slide
                  exit={i !== activeReview}
                  enter={i === activeReview}
                  direction="left"
                  in={i === activeReview}
                  appear
                  timeout={{ enter: 1000, exit: 1000 }}
                >
                  <Paper
                    elevation={0}
                    style={{ height: i === activeReview ? "auto" : 0 }}
                  >
                    <CardContent>
                      <Typography gutterBottom>
                        {reviews[activeReview].title}
                      </Typography>
                      <Typography
                        variant="body2"
                        color="textSecondary"
                        component="p"
                      >
                        {reviews[activeReview].message}
                      </Typography>
                    </CardContent>
                  </Paper>
                </Slide>
              ))}
              <CardActions>
                <IconButton
                  onClick={() => setActiveReview(activeReview - 1)}
                  color="primary"
                  disabled={activeReview === 0}
                >
                  <ChevronLeftRounded />
                </IconButton>
                <IconButton
                  onClick={() => setActiveReview(activeReview + 1)}
                  style={{ marginLeft: "auto" }}
                  color="primary"
                  disabled={activeReview === reviews.length - 1}
                >
                  <ChevronRightRounded />
                </IconButton>
              </CardActions>
            </Card>
          </Grid>
        </Grid>

        <Box mt={10} />
        <Grid container spacing={3} justify="center">
          <Grid item xs={12} sm={12} md={5}>
            <Box
              display="flex"
              justifyContent="flex-start"
              alignItems="center"
              width={1}
              ref={requestRef}
            >
              <Typography variant="h4" gutterBottom>
                <b>Interested in our services?</b>
              </Typography>
            </Box>
            <Box display="flex" justifyContent="flex-start" mb={2} width={1}>
              <Box width={1}>
                <Typography gutterBottom variant="h6">
                  feel free to request a meeting with us.
                </Typography>
              </Box>
            </Box>
            <Box display="flex" alignItems="flex-start" p={1}>
              <Box mt="3px" mr={2}>
                {" "}
                <RadioButtonCheckedRounded color="primary" fontSize="small" />
              </Box>
              <Typography>
                Streamline all your dairly operations with efficient
                technologeis.
              </Typography>
            </Box>
            <Box display="flex" alignItems="flex-start" p={1}>
              <Box mt="3px" mr={2}>
                {" "}
                <RadioButtonCheckedRounded color="primary" fontSize="small" />
              </Box>
              <Typography>
                Automated ticket control,validation & payment solutions.
              </Typography>
            </Box>
            <Box display="flex" alignItems="flex-start" p={1}>
              <Box mt="3px" mr={2}>
                {" "}
                <RadioButtonCheckedRounded color="primary" fontSize="small" />
              </Box>
              <Typography>
                Save precious time and invest it where you need it the most.
              </Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={12} md={5}>
            <Paper className={classes.paper} elevation={0}>
              <Box mb={1}>
                <TextField
                  fullWidth
                  color="primary"
                  label="Full name"
                  placeholder="Enter your full name"
                  size="medium"
                />
              </Box>
              <Box mb={1}>
                <TextField
                  fullWidth
                  color="primary"
                  label="Email"
                  placeholder="Enter your email address"
                  size="medium"
                />
              </Box>
              <Box mb={1}>
                <TextField
                  fullWidth
                  color="primary"
                  label="Phone number"
                  placeholder="Enter your phone number"
                  size="medium"
                />
              </Box>
              <Box mb={1}>
                <TextField
                  fullWidth
                  color="primary"
                  label="Interested in"
                  placeholder="What are you interested in?"
                  size="medium"
                />
              </Box>

              <Box mt={2}>
                {" "}
                <FormControlLabel
                  control={<Checkbox name="terms" />}
                  label="Agree to our Terms&Conditions?"
                />
              </Box>
              <Box mt={2}>
                <Button
                  disableElevation
                  color="primary"
                  variant="contained"
                  fullWidth
                  size="large"
                  className={classes.btn}
                >
                  Send request
                </Button>
              </Box>
            </Paper>
          </Grid>
        </Grid>
        <Box mt={10} />

        <Grid container spacing={3} justify="center">
          <Grid item xs={12} sm={12} md={10}>
            <Paper className={classes.paper} elevation={0}></Paper>
          </Grid>
        </Grid>
        <Box mt={5} />

        <Box width={1} mb={5} justifyContent="center">
          <Typography variant="h4" gutterBottom align="center">
            <b>We are social</b>
          </Typography>
          <Box
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            <Typography gutterBottom variant="h6" align="center">
              Folow us on our twitter handle
            </Typography>
          </Box>
        </Box>
      </Container>
      <ScrollTop {...props}>
        <Fab color="secondary" size="small" aria-label="scroll back to top">
          <KeyboardArrowUpRounded />
        </Fab>
      </ScrollTop>
      <Footer />
    </React.Fragment>
  );
}
